import React from 'react';
import { Container, Row, Col,Button } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';

export const UnAuth=(props) => {
    const { logout } = useAuth();

    const getMessage = function () {
            //Conditionally handle auth
        switch (props.errorCode) {
            case "35438516-B50C-40D2-A9BB-DBD3E7988CCE":
                return (
                    <div>
                        <p>
                            Once your One Healthcare ID registration has been completed, it may take up to 5 minutes to activate in the Payment Services Supplier Portal.
                       <br/>
                            Please attempt to sign-on again. For support issues please contact <a href='mailto://support@supplierportal.uhg.com'>support@supplierportal.uhg.com</a>
                        </p>
                    </div>);
            /* break;*/
            case "CB3C64EE-F35F-4CB3-AE7C-52E9CE710282":
                return (
                    <div>
                        <p>
                            Once your One Healthcare ID registration has been completed, it may take up to 5 minutes to activate in the Payment Services Supplier Portal.
                            <br />
                            Please attempt to sign-on again. For support issues please contact <a href='mailto://supplier_help@uhg.com'>supplier_help@uhg.com</a>
                        </p>
                    </div>);
            case "202F9ED5-6B73-4B4D-847C-F3B5BFB0A157":
                //Phase 2.2 Mismatched Emails
                return (
                    <div>
                        <p>Some common reasons:</p>
                        <ul>
                            
                            <li>Portal account locked</li>
                            <li>Portal account inactive</li>
                            <li>Portal account does not exist - registered with OHCID but no user account in portal</li>
                        </ul>
                    </div>);
               /* break;*/
            case "818C4F7C-2DBC-49F4-9ECF-FE4FD1248AF5":
                //Phase 2.2 No Account
                return (
                    <div>
                        <p>Some common reasons:</p>
                        <ul>
                            <li>Portal account does not exist - registered with OHCID but no user account in portal</li>
                            <li>Portal account locked</li>
                            <li>Portal account inactive</li>
                            <li>Mismatched email between Portal & One Healthcare ID</li>
                        </ul>
                    </div>);
            /* break;*/
            case "3824C2EE-F306-4A6F-9177-29B5D2ADE1BE":
                //US7652820 and US7652823 - LOCKED or Disabled Account
                return (
                    <div>
                        <p>Some common reasons:</p>
                        <ul>
                            <li>Portal account is locked or disabled</li>
                            <li>Portal account is inactive</li>
                            <li>Portal account does not exist - registered with OHCID but no user account in portal</li>
                            <li>Mismatched email between Portal & One Healthcare ID</li>
                        </ul>
                    </div>);
            /* break;*/
            default:
                //Generic error message
                return (
                    <div>
                        <p>Some common reasons:</p>
                        <ul>
                            <li>Portal account locked</li>
                            <li>Portal account inactive</li>
                            <li>Portal account does not exist - registered with OHCID but no user account in portal</li>
                            <li>Mismatched email between Portal & One Healthcare ID</li>
                        </ul>
                    </div>);
               /* break;*/
        }
    }  

      return (
          <Container>
              <h3>Not Authorized to access this site.</h3>
              <Row>
                  <Col>
                      <div> General authentication error: {props.errorCode}</div>
                      {getMessage()}
                      <div>
                      <Button style={{justifyContent:'center'}} onClick={() => { logout() }}>OK</Button>
                      </div>
                  </Col>
              </Row>
          </Container>
    );
}
